export default __webpack_public_path__ + "static/bloom-v1-mobile-bbf5b67fc5e029cd73a688c23a6377c7.mp4";